const inIframe = (): boolean => {
    try {
        return window.self !== window.top;
    } catch (_e) {
        return true;
    }
};

export default inIframe;
